import React from "react";
import { CONTAINER } from "../ui";
import { STATS } from "../content";

export default function StatsStrip() {
  return (
    <section className="tw-border-y tw-border-[#dce8f2] tw-bg-white">
      <div
        className={`${CONTAINER} tw-grid tw-grid-cols-3 tw-divide-x tw-divide-y-0 tw-divide-[#dce8f2] sm:tw-grid-cols-1 sm:tw-divide-x-0 sm:tw-divide-y`}
      >
        {STATS.map((stat) => (
          <div key={stat.label} className="tw-py-10 tw-text-center sm:tw-py-8">
            <p className="tw-m-0 tw-text-4xl tw-font-black tw-tracking-[-.04em] tw-text-[#087bd3]">
              {stat.value}
            </p>
            <p className="tw-mt-1 tw-mb-0 tw-text-sm tw-font-bold tw-text-[#60768c]">{stat.label}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
